/**
 * Create the store with dynamic reducers
 */
import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import thunk from 'redux-thunk';
import produce from 'immer';
import createReducer from './reducers';
import { extraDataLayer } from './middleware/userEvents';
export default function configureStore(initialState, history) {
    if (initialState === void 0) { initialState = {}; }
    // Create the store with two middlewares
    // 1. sagaMiddleware: Makes redux-sagas work
    // 2. routerMiddleware: Syncs the location/URL path to the state
    var middlewares = [thunk, routerMiddleware(history), extraDataLayer];
    var enhancers = [applyMiddleware.apply(void 0, middlewares)];
    // If Redux DevTools Extension is installed use it, otherwise use Redux compose
    /* eslint-disable no-underscore-dangle, indent */
    var composeEnhancers = process.env.NODE_ENV !== 'production' &&
        typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
        ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // TODO Try to remove when `react-router-redux` is out of beta, LOCATION_CHANGE should not be fired more than once after hot reloading
            // Prevent recomputing reducers for `replaceReducer`
            shouldHotReload: false,
        })
        : compose;
    /* eslint-enable */
    var store = createStore(createReducer(), 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    produce(initialState, function () { }), composeEnhancers.apply(void 0, enhancers));
    // Extensions
    store.injectedReducers = {}; // Reducer registry
    // Make reducers hot reloadable, see http://mxs.is/googmo
    /* istanbul ignore next */
    if (module.hot) {
        module.hot.accept('./reducers', function () {
            store.replaceReducer(createReducer(store.injectedReducers));
        });
    }
    return store;
}
